// ajuste o import conforme o tipo real do SES no projeto

let sesCache: any[] | null = null;

export function getSesMemoryCache() {
  return sesCache;
}

export function setSesMemoryCache(data: any[]) {
  sesCache = data;
}

export function clearSesMemoryCache() {
  sesCache = null;
}

// services/cache/useSesCache.ts
import { useEffect, useState } from 'react';

import { getAllSes } from '../ses/sesService';

export function useSesCache() {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const cached = getSesMemoryCache();
    if (cached) {
      setData(cached);
      return;
    }

    setLoading(true);
    getAllSes()
      .then((result) => {
        setData(result);
        setSesMemoryCache(result);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loading };
}
